import { Spacing } from '@persona-id/design-tokens';

import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Paragraph } from 'design-system/components/Text';

interface DeletePresetModalProps {
  handleArchivePreset: () => Promise<void>;
  isArchivingPreset: boolean;
  hideModal: () => void;
}

export const DeletePresetModal = ({
  handleArchivePreset,
  isArchivingPreset,
  hideModal,
}: DeletePresetModalProps) => {
  return (
    <ModalContainer>
      <ModalHeader onClose={hideModal}>Delete this preset?</ModalHeader>
      <ModalBody>
        <Paragraph>
          Each preset is saved for the whole organization and once deleted, will be removed
          permanently for everyone.
        </Paragraph>
        <Spacer height={2} />
        <Paragraph>Are you sure you want to delete this preset?</Paragraph>
        <Spacer height={2} />
        <HStack equal={true} spacing={Spacing[4]}>
          <Button
            variant='basic'
            id='delete-preset-modal__cancel'
            disabled={isArchivingPreset}
            onClick={hideModal}
          >
            Cancel
          </Button>
          <Button
            id='delete-preset-modal__submit'
            disabled={isArchivingPreset}
            isPending={isArchivingPreset}
            variant='danger'
            onClick={handleArchivePreset}
          >
            Delete
          </Button>
        </HStack>
      </ModalBody>
    </ModalContainer>
  );
};
